export const USER_TYPE_CODE = {
  REGULAR: "regular",
  SUPERVISOR: "supervisor",
} as const;

export type UserTypeCode = (typeof USER_TYPE_CODE)[keyof typeof USER_TYPE_CODE];

export const USER_DEPARTMENT_CODE = {
  ALL: "all",
  PACKAGING: "packaging",
  PRODUCTION: "production",
  RECEIVING: "receiving",
  SHIPPING: "shipping",
  ORDERS: "orders",
} as const;

export type UserDepartmentCode =
  (typeof USER_DEPARTMENT_CODE)[keyof typeof USER_DEPARTMENT_CODE];
